



































































import Vue from 'vue'
import * as Tone from 'tone'
import { KeyScaleDegree, KeyScaleChord } from '@/application/models/ScaleInKey'
import { Inversion, VariantType, variants } from '@/application/models/chords'
import { playChord } from '@/application/TonePlayer'
import IconPlay from '@/assets/icons/icon-play.svg'
import IconAddSquare from '@/assets/icons/icon-add-square.svg'
import IconCheveronUp from '@/assets/icons/icon-cheveron-up.svg'
import IconCheveronDown from '@/assets/icons/icon-cheveron-down.svg'
import { SetChordParameters } from '../application/models/chordProgression'
import { minOctave, maxOctave, defaultOctave } from '@/application/models/octaves'
import { mapState } from 'vuex'

export default Vue.extend({
  props: {
    degree: { type: KeyScaleDegree },
    sampler: { type: Tone.Sampler },
    samplerLoaded: { type: Boolean },
    variant: { type: VariantType, default: () => variants[0] },
    inversion: { type: Number, default: 0 },
    octave: { type: Number, default: defaultOctave },
    showPlay: { type: Boolean, default: true },
    selectable: { type: Boolean, default: false },
    editable: { type: Boolean, default: true }
  },
  components: {
    IconPlay,
    IconAddSquare,
    IconCheveronUp,
    IconCheveronDown
  },
  data() {
    const typedVariant = this.variant as VariantType<KeyScaleChord>
    const root: Inversion = typedVariant.func(this.degree.chords).chord.inversions[this.inversion]
    return {
      variants,
      selectedVariant: typedVariant,
      selectedInversion: root,
      selectedOctave: this.octave,
      minOctave: minOctave,
      maxOctave: maxOctave,
      hovered: false
    }
  },
  computed: {
    ...mapState('app', [
      'keyBindingsActive'
    ]),
    keyScaleChord(): KeyScaleChord {
      return this.selectedVariant.func(this.degree.chords)
    },
    inversions(): Inversion[] {
      return this.keyScaleChord.chord.inversions
    },
    cssClass(): string {
      return this.degree.chordFunction.cssClass
    },
    className(): string {
      return `has-background-${this.cssClass}`
    },
    topClassName(): string {
      return `${this.className} ${this.hovered ? 'hovered': ''}`
    },
    title(): string {
      const degree = this.degree.degree
      const chord = this.keyScaleChord.chordName
      return `${degree} : ${chord} : ${this.selectedInversion.name} inversion : ${this.degree.chordFunction.name} function`
    },
    keymap(): Keymap {
      const deg = `deg${this.degree.degree}`
      return this.keyBindingsActive ? {
        [deg]: this.play
      } : {}
    }
  },
  watch: {
    inversions() {
      // If you switch form 7th to triad there are fewer invesions, so make sure we're on one that exists
      if(!this.inversions[this.selectedInversion.number]) {
        this.selectedInversion = this.inversions[this.inversions.length-1]
      }
    },
    selectedVariant() {
      this.$emit('change:variant', this.selectedVariant)
    },
    selectedInversion() {
      this.$emit('change:inversion', this.selectedInversion)
    },
    selectedOctave() {
      this.$emit('change:octave', this.selectedOctave)
    },
    variant(variant: VariantType<KeyScaleChord>) {
      this.selectedVariant = variant
    },
    inversion(inversion: number) {
      this.selectedInversion = this.inversions[inversion]
    },
    octave(octave: number) {
      this.selectedOctave = octave
    }
  },
  methods: {
    play() {
      playChord(this.sampler as Tone.Sampler, this.keyScaleChord, this.selectedInversion.number, '1m', this.selectedOctave)
    },
    select() {
      this.$emit('select', { variant: this.selectedVariant, inversion: this.selectedInversion.number, octave: this.selectedOctave })
    },
    onMousedown(event: MouseEvent) {
      if(!this.selectable) {
        event.preventDefault()
      }
    },
    getChordParameters(): SetChordParameters {
      return {
        degree: this.degree.degree,
        variantType: this.selectedVariant,
        inversion: this.selectedInversion.number,
        octave: this.selectedOctave
      }
    }
  }
})
